import {
  Text,
  Button,
  Divider,
  HStack,
  VStack,
  ButtonGroup,
  useToast
} from "@chakra-ui/react";
import { useVoiceprintStore } from "../store";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from "../constants/api";
import { useState } from "react";

const Summary = ({ setProgress, accessToken }) => {
  const {
    setCurrentStep,
    external_id,
    speech_duration,
    setStreamId,
    name,
    setName,
    setExternalId,
    setSpeechDuration
  } = useVoiceprintStore();

  const [isLoading, setIsLoading] = useState(false);
  const [deleteIsLoading, setDeleteIsLoading] = useState(false);
  const [newVpIsLoading, setNewVpIsLoading] = useState(false);
  const [buttonInterval, setButtonInterval] = useState(40);

  const toast = useToast();
  let buttonCounter = 0;

  const deleteVoiceprint = setIsLoading => {
    setIsLoading(true);
    axios
      .delete(
        `${BASE_URL}/voice/delete`,
        {
          data: {
            external_uid: external_id
          }
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          toast({
            title: "Successfully Deleted Voiceprint",
            status: "success",
            duration: 2000,
            isClosable: true
          });

          setTimeout(() => {
            setIsLoading(false);
            setCurrentStep("new");

            setName(null);
            setStreamId(null);
            setExternalId(null);
            setSpeechDuration("0");
          }, 1000);
        }
      })
      .catch(err => {
        setIsLoading(false);
        console.error("End Call Error: ", err);
      });
  };

  const handleNewVoiceprint = e => {
    deleteVoiceprint(setNewVpIsLoading);
  };

  const handleDelete = e => {
    deleteVoiceprint(setDeleteIsLoading);
  };

  const handleVerify = e => {
    console.log("verify");
    setProgress("00");
    setIsLoading(true);

    toast({
      title: "Initiating Verification Call",
      description:
        "Please wait while we initiate a call to your number for verification purposes.",
      status: "loading",
      duration: 5000,
      isClosable: true
    });

    axios
      .post(
        `${BASE_URL}/initiate_call/verify`,
        { external_id, name: "" },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          // Verify voice print => 5 seconds

          let call_interval = null;
          let counter = 0;

          let button_interval = null;

          if (!button_interval) {
            button_interval = setInterval(() => {
              buttonCounter += 1000;
              setButtonInterval(prev => prev - 1);
              if (buttonCounter >= 40000) {
                buttonCounter = 0;
                clearInterval(button_interval);
                button_interval = null;
                setButtonInterval(40);
                setIsLoading(false);
              }
            }, 1000);
          }

          if (!call_interval) {
            call_interval = setInterval(() => {
              counter += 3000;

              if (counter >= 40000) {
                toast({
                  title: "Trying Again.",
                  description:
                    "It seems like you did not receive or attend the call. Let's try that again",
                  status: "info",
                  duration: 3000,
                  isClosable: true
                });

                counter = 0;
                clearInterval(call_interval);
                call_interval = null;
                handleVerify();
                // return;
              }

              axios
                .get(
                  `${BASE_URL}/check_call_status?external_uid=${external_id}`,
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`
                    }
                  }
                )
                .then(res2 => {
                  if (res2.status === 200 && res2.data.active === true) {
                    console.log(res2.data);

                    toast({
                      title: "Call Initiated",
                      status: "success",
                      duration: 2000,
                      isClosable: true
                    });

                    setIsLoading(false);
                    setStreamId(res2.data.stream_uid);
                    setCurrentStep("verify"); // Here we go to next step
                    clearInterval(call_interval);
                  }
                })
                .catch(err => {
                  setIsLoading(false);
                  console.error(err);
                });
            }, 3000);
          }
        } else {
          setIsLoading(false);
          console.error(res);
        }
      })
      .catch(err => console.error(err));
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -200 }}
        style={{ width: "100%" }}
      >
        <Text fontSize="xl" color="gray.400" mt={-4}>
          Verify your voice
        </Text>

        <VStack spacing="22px" w="100%" mt={5} alignItems="flex-start">
          <Text fontSize="md" textColor="black" fontWeight="medium">
            Call Summary
          </Text>

          <Divider />
          <HStack w="full" justify="space-between">
            <Text fontSize="md" textColor="black">
              User
            </Text>
            <Text fontSize="md" textColor="black">
              {name}
            </Text>
          </HStack>

          <HStack w="full" justify="space-between">
            <Text fontSize="md" textColor="black">
              Phone Number
            </Text>
            <Text fontSize="md" textColor="black">
              {external_id}
            </Text>
          </HStack>

          <HStack w="full" justify="space-between">
            <Text fontSize="md" textColor="black">
              Call Duration
            </Text>
            <Text fontSize="md" textColor="black">
              {speech_duration}
            </Text>
          </HStack>

          {/* <HStack w="full" justify="space-between">
          <Text fontSize="md" textColor="black">
            User
          </Text>
          <Text fontSize="md" textColor="black">
            User
          </Text>
        </HStack> */}

          <Text fontSize="sm" textAlign="left">
            Click the VERIFY button to verify your voice based on your
            previously created voiceprint.
          </Text>

          <ButtonGroup w="full" spacing="15px">
            <Button
              size="lg"
              w="100%"
              color="black"
              bgColor="white"
              borderColor="black"
              borderWidth={1}
              borderRadius={0}
              onClick={handleDelete}
              isLoading={deleteIsLoading}
            >
              Delete
            </Button>
            {isLoading === false ? (
              <Button
                size="lg"
                w="100%"
                color="white"
                bgColor="black"
                borderRadius={0}
                onClick={handleVerify}
                isLoading={isLoading}
              >
                Verify
              </Button>
            ) : (
              <Button
                size="lg"
                w="100%"
                color="white"
                bgColor="black"
                fontSize="xs"
                disabled
                borderRadius={0}
              >
                Trying again in {buttonInterval} seconds
              </Button>
            )}
          </ButtonGroup>

          <Divider w="full" bgColor="black" variant="dashed" />
          <Button
            size="lg"
            mt="10"
            w="100%"
            color="white"
            bgColor="black"
            isLoading={newVpIsLoading}
            onClick={handleNewVoiceprint}
          >
            Create New Voiceprint
          </Button>
        </VStack>
      </motion.div>
    </AnimatePresence>
  );
};

export default Summary;
